const mutationTypes = {
  SET_DRAFT: 'SET_DRAFT',

  // groups
  ADD_GROUP: 'ADD_GROUP',
  SET_EDIT_GROUP: 'SET_EDIT_GROUP',
  UPDATE_EDIT_GROUP: 'UPDATE_EDIT_GROUP',
  REMOVE_GROUP: 'REMOVE_GROUP',

  // questions
  ADD_QUESTION: 'ADD_QUESTION',
  SET_EDIT_QUESTION: 'SET_EDIT_QUESTION',
  UPDATE_EDIT_QUESTION: 'UPDATE_EDIT_QUESTION',
}

const actionTypes = {
  FETCH_DRAFT: 'FETCH_DRAFT',

  // groups
  SAVE_GROUP: 'CREATE_GROUP',
  MOVE_GROUP_UP: 'MOVE_GROUP_UP',
  MOVE_GROUP_DOWN: 'MOVE_GROUP_DOWN',
  DELETE_GROUP: 'DELETE_GROUP',

  // questions
  SAVE_QUESTION: 'SAVE_QUESTION',
  MOVE_QUESTION_UP: 'MOVE_QUESTION_UP',
  MOVE_QUESTION_DOWN: 'MOVE_QUESTION_DOWN',
  DELETE_QUESTION: 'DELETE_QUESTION',
}

const getTypes = {
  HIGHLIGHTED_GROUPS: 'HIGHLIGHTED_GROUPS',
  HIGHLIGHTED_QUESTION: 'HIGHLIGHTED_QUESTION',
  EDIT_ACTIVE: 'EDIT_ACTIVE',
}

export { mutationTypes, actionTypes, getTypes }



// WEBPACK FOOTER //
// ./src/store/modules/DraftsTypes.js